import type { TgeClaimTokensResult } from '@reyaxyz/common';

export {
  GetReyaCheckerResult,
  TgeAllocatedAmount,
  GetTgeClaimingInfoResult,
  TrancheInfo,
  TgeClaimTokensResult,
} from '@reyaxyz/common';

import { Signer } from 'ethers';

export type GetReyaCheckerParams = {
  wallet: string;
};

export type GetTgeClaimingInfoParams = {
  wallet: string;
};

export type TgeClaimTokensParams = {
  signer: Signer;
  distributorContract: string;
  merkleRoot: string;
};

export type TgeLockTokensParams = TgeClaimTokensParams;

export type TgeLockTokensResult = TgeClaimTokensResult;
